import PropTypes from 'prop-types';
import { memo, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Modal from '../../Modal';
import TourSearchBar from './TourSearchBar';
import TourFilters from './TourFilters';
import TourList from './TourList';
import ToursModalContent from './ToursModalContent';
import SortingFilter from '../../Filters/SortingFilter';
import { setTourTripSearchParam, tourSearchRequest } from '../../../store/slices/tripSearch';
import { tourRemainingSearchStop } from '../../../store/slices/tour';
import { TourFiltersInitialValue, TourSortingValues } from '../../../constants';

const TourInformation = ({ tripId }) => {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isTripSearch = !tripId;
  const searchObj = useSelector((store) => store.tripSearch.searchObj.tour);

  useEffect(
    () => () => {
      dispatch(tourRemainingSearchStop({ tripId, isTripSearch }));
    },
    [dispatch, tripId, isTripSearch],
  );

  const handleOpenModal = useCallback(() => setIsModalOpen(true), []);
  const handleCloseModal = useCallback(() => setIsModalOpen(false), []);

  const handleSortChange = useCallback(
    (sorting) => {
      dispatch(setTourTripSearchParam({ ...sorting, page: 1 }));
      dispatch(tourSearchRequest({ isTripSearch, tripId }));
    },
    [dispatch, isTripSearch, tripId],
  );

  return (
    <div className="mx-5 my-5">
      <TourSearchBar tripId={tripId} />
      <div className="font-bold">Filter by</div>
      <TourFilters tripId={tripId} />
      <div className="mt-10 mb-5 font-bold flex justify-between items-center">
        Best tours
        <SortingFilter
          sortingValues={TourSortingValues}
          initialValue={TourFiltersInitialValue.sortBy}
          value={searchObj?.sortBy}
          direction={searchObj?.sortDirection}
          onSortChange={handleSortChange}
          variant="transparentOutline"
        />
      </div>
      <TourList tripId={tripId} isModalOpen={isModalOpen} onViewMoreClick={handleOpenModal} />

      <Modal open={isModalOpen} onClose={handleCloseModal}>
        <div className="px-8 grid grid-flow-col auto-cols-max gap-5 font-bold border-b-2">
          <a
            role="button"
            tabIndex="-1"
            className="text-theme border-b-2 border-theme py-4 w-24 text-center"
          >
            Tour
          </a>
        </div>
        <ToursModalContent tripId={tripId} onViewLessClick={handleCloseModal} />
      </Modal>
    </div>
  );
};

TourInformation.propTypes = {
  tripId: PropTypes.string.isRequired,
};

export default memo(TourInformation);
